import { template as template_604d0a019b6e43f28450b8d07fe1056a } from "@ember/template-compiler";
import Component from '@glimmer/component';
export default class MultipieceIcon extends Component {
    get iconColorClass() {
        if (this.args.iconColorClass != null) {
            return this.args.iconColorClass;
        }
        return 'bg-black';
    }
    static{
        template_604d0a019b6e43f28450b8d07fe1056a(`
    <span class="multipiece-icon">
      <span class="mp-rectangle mp-top {{this.iconColorClass}}"></span>
      <span class="mp-rectangle mp-middle {{this.iconColorClass}}"></span>
      <span class="mp-rectangle mp-bottom {{this.iconColorClass}}"></span>
    </span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
